export default __webpack_public_path__ + "static/media/token_left_tablet.0e950b02.png";